// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3YSR9","footer":"ModalInfo_footer__q3bs2"};